import React, { Component } from 'react';

import {
    Spin,
    Card,
    Statistic,
    Button,
} from 'antd';

import { CheckCircleTwoTone, StarFilled } from '@ant-design/icons';

class UpgradeBanner extends Component {
    render() {
        const benefits = [
            'Get Full Broken Links Reports',
            'Email & Live Chat Support',

            'Find Broken Amazon Links',
            'Find Wrong and Missing Affiliate Tags',
            'Find Low Quality Products',
            'Check International Amazon Stores',
            'Daily Checking and Reporting',
            'Monitor Your Website or YouTube Channel',
            'Uncapped Daily Page Checks',
            'Find Alternatives To Amazon Products',
        ];
        return (
            <Card title={<div style={{ textAlign: 'center' }}>Upgrade Your Account</div>} bodyStyle={{ padding: '12px 20px' }} size="small" style={{ width: 375 }}>
                <div style={{ fontSize: 15 }}>Gain access to more features when you upgrade to a paid plan:</div>
                <div style={{ margin: '10px 0'}}>
                    {benefits.map(b => <div style={{ marginTop: 3 }} key={b}><CheckCircleTwoTone style={{ marginRight: 5 }} /> {b}</div>)}
                </div>
                <div style={{ fontSize: 15, margin: '15px 10px', textAlign: 'center' }}>Get up to 20% off your yearly subscription to AMZ Watcher.</div>
                <div style={{ display: 'flex', justifyContent: 'center', margin: '10px 0 0 0' }}>
                    <Button className="amzw-button amzw-button-banner"><a href="https://amzwatcher.com/pricing/" target="_blank">Get The Discount</a></Button>
                </div>
                
                <div style={{ textAlign: 'center', fontSize: 11, color: 'grey' }}>*discount applied automatically</div>
                <div style={{ margin: '10px 0' }} className="amzw-testimonial">
                    <div style={{ textAlign: 'center' }} >
                        <span style={{ fontSize: 16 }}>Matt Diggity</span>
                        <div>
                            <StarFilled />
                            <StarFilled />
                            <StarFilled />
                            <StarFilled />
                            <StarFilled />
                        </div>
                    </div>
                    <span>"AMZ Watcher is a smart tool. Takes a 6 hour task and reduces it to 6 seconds."</span>
                </div>
                <div style={{ margin: '10px 0' }} className="amzw-testimonial">
                    <div style={{ textAlign: 'center' }} >
                        <span style={{ fontSize: 16 }}>Dom Wells</span>
                        <div>
                            <StarFilled />
                            <StarFilled />
                            <StarFilled />
                            <StarFilled />
                            <StarFilled />
                        </div>
                    </div>
                    <span>"AMZ Watcher is a great tool. We have it monitoring most of our sites now and regularly find broken links, so it’s a big time saver and money maker."</span>
                </div>
            </Card>
        );
    }
}

export default UpgradeBanner;